;document.addEventListener( 'DOMContentLoaded', function () {
	const $ = window.jQuery;
	const $requestInfoForms = $( '#request-info-form,#exit-intent-form' );

	if ( 1 > $requestInfoForms.length ) {
		return;
	}

	function showPrograms( $form, campus ) {
		console.log( 'showing for ', $form, campus );
		if ( 49 === campus ) {
			$form.find( '[name="requestFormSelectProgramFld"]' )
			     .attr( 'required', '' )
			     .parent()
			     .removeClass( 'd-none' );
			$form.find( '[name="requestFormSelectProgramWpb"]' )
			     .removeAttr( 'required' )
			     .parent()
			     .addClass( 'd-none' );
		} else if ( 50 === campus ) {
			$form.find( '[name="requestFormSelectProgramFld"]' )
			     .removeAttr( 'required' )
			     .parent()
			     .addClass( 'd-none' );
			$form.find( '[name="requestFormSelectProgramWpb"]' )
			     .attr( 'required', '' )
			     .parent()
			     .removeClass( 'd-none' );
		}
	}

	$( '[name="requestFormSelectCampus"]' ).on( 'change', e => {
		const $currentForm = $( e.target ).closest( 'form' );
		const campus = parseInt( $( e.target ).val(), 10 );
		showPrograms( $currentForm, campus );
	} );

	$requestInfoForms.each( ( _, form ) => {
		const $form = $( form );
		const preselectedCampus = $form.find( '[name="requestFormSelectCampus"]' ).val();

		console.log( preselectedCampus, $form.attr( 'id' ), $form );

		if ( preselectedCampus ) {
			showPrograms( $form, preselectedCampus );
		}
	} );
} );
